'use strict';

import {http} from '../utils';



class ServiceForm extends HTMLFormElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }

  init() {
    this._active = 0;
    this._activeContainer = null;
    this._scroll = 0;

    this._action = this.action;

    this.addEventListener('submit', ev => ev.preventDefault());
  }

  connectedCallback() {
    this._scrollElem = document.querySelector('.serviceFormScroll');
    this._titleElement = this.querySelector('.serviceFormTitle');
    this._progressCounter = this.querySelector('.serviceFormCounter');
    this._containers = Array.from(this.querySelectorAll('.serviceFormContainer'));
    this._titles = this._containers.map(el => el.dataset.title);
    this._fieldsetSelect = this.querySelector('.serviceFormFieldsetSelect');
    this._fieldsets = {};
    this._responseContainer = this.querySelector('.serviceFormResponseContainer');
    this._responseInner = this.querySelector('.serviceFormResponse');
    this._previousButtons = Array.from(this.querySelectorAll('.serviceFormBack'));
    this._nextButtons = Array.from(this.querySelectorAll('.serviceFormNext'));
    this._submitButtons = Array.from(this.querySelectorAll('.serviceFormSubmit'));

    const localStorageData = localStorage.getItem('service-form');
    if (localStorageData) {
      const obj = JSON.parse(localStorageData);

      Object.entries(obj).forEach(([key, value]) => {
        // if (!value) return;

        const elem = this.querySelector(`[name=${key}]`);
        const tagName = elem.tagName.toLowerCase();

        if (tagName === 'input') {
          const elemType = elem.type.toLowerCase();
          if (elemType === 'checkbox') {
            elem.checked = value;
          } else {
            elem.value = value;
          }
        } else if (tagName === 'textarea') {
          elem.value = value;
        } else if (tagName === 'select') {
          elem.parentNode.value = value;

          // if (elem.parentNode === this._se)
        }
      });
    }

    Array.from(this.querySelectorAll('.serviceFormFieldsetType')).forEach(el => {
      const key = el.dataset.type;
      this._fieldsets[key] = {
        key,
        el
      }
    });
    this._fieldsetSelect.onUpdate = (selected, value) => {
      const activeFields = value.split(',');

      Object.values(this._fieldsets).forEach((obj) => {
        let isActive = false;

        for (let i = 0; activeFields.length > i; i++) {
          if (activeFields[i] === obj.key) {
            isActive = true;
            break;
          }
        }
        obj.el.disabled = !isActive;
      })
    }

    this._activeContainer = this._containers[this._active];


    Array.from(this.querySelectorAll('input[type=text], textarea')).forEach(el => {
      el.addEventListener('focus', () => el.parentNode.classList.add('focus'));
      el.addEventListener('blur', () => el.parentNode.classList.remove('focus'));
    })


    this._previousButtons.forEach(button => {
      button.addEventListener('click', () => this._prev());
    });
    this._nextButtons.forEach(button => {
      button.addEventListener('click', () => this._next());
    });
    this._submitButtons.forEach(button => {
      button.addEventListener('click', () => this._submit());
    });

    this.addEventListener('change', ev => this._localStorageUpdate());
  }

  disconnectedCallback() {
  }

  _localStorageUpdate() {
    // const json = JSON.stringify(Object.fromEntries(new FormData(this)));
    const obj = {};

    Array.from(this.elements).forEach(elem => {
      const tagName = elem.tagName.toLowerCase();
      const name = elem.getAttribute('name');
      if (!name) return;

      if (tagName === 'input') {
        const elemType = elem.type.toLowerCase();
        if (elemType === 'checkbox') {
          obj[name] = elem.checked;
        } else {
          obj[name] = elem.value;
        }
      } else if (tagName === 'textarea') {
        obj[name] = elem.value;
      } else if (tagName === 'select') {
        obj[name] = elem.value;
      }
    })

    localStorage.setItem('service-form', JSON.stringify(obj));
  }

  _prev() {
    this._active--;
    if (this._active < 0) this._active = 0;

    this._updateProgressCounter();
    this._changeView(this._containers[this._active]);
  }
  _next() {
    this._active++;
    if (this._active >= this._containers.length) this._active = this._containers.length - 1;


    this._updateProgressCounter();
    this._changeView(this._containers[this._active]);
  }
  _changeView(container) {
    if (container === this._activeContainer) return;

    this.classList.remove('submitted');

    if (this._activeContainer) {
      this._activeContainer.classList.remove('active');
    }
    container.classList.add('active');
    this._activeContainer = container;

    TweenMax.fromTo(this, 0.3, {
      _scroll: this._scrollElem.scrollTop
    }, {
      _scroll: 0,
      onUpdate: () => this._scrollElem.scrollTop = this._scroll
    })

  }
  _updateProgressCounter() {
    this._titleElement.innerHTML = this._titles[this._active];
    this.style.setProperty('--progress', `${(this._active + 1) / this._containers.length}`);
    this._progressCounter.innerHTML = `${this._active + 1} / ${this._containers.length}`;
  }

  _submit() {
    this._responseContainer.classList.remove('error');
    this.classList.add('loading');
    this.disabled = true;

    const data = new FormData(this);

    http({action: this._action, data: data})
      .then(e => {
        if (e.status === 'success') {
          this._onSuccess(e);
        } else {
          this._onError(e.response.title);
        }
      })
      .catch(e => this._onError(e));
  }
  _onSuccess(e) {
    this._responseInner.innerHTML = e.response.title;

    this._changeView(this._responseContainer);

    this.reset();
    localStorage.removeItem('service-form');

    this.classList.remove('loading');
    this.classList.add('submitted');
    this.disabled = false;
  }
  _onError(message) {
    this._responseInner.innerHTML = message;

    this._changeView(this._responseContainer);

    this._responseContainer.classList.add('error');

    this.classList.remove('loading');
    this.classList.add('submitted');
    this.disabled = false;

    console.log(message);
  }
}

window.customElements.define('service-form', ServiceForm, {extends: 'form'});